import lang from "@/views/modules/InstitutionalDocs/language/en";
let metaList = [
    {
        label: lang.LBL_PI_NAME,
        link: true,
        columnName: 'assigned_user',
    },
    {
        label: lang.LBL_PI_MOBILE,
        link: false,
        columnName: 'mobile',
    },
    {
        label: lang.LBL_PI_PROFESSIONAL,
        link: false,
        columnName: 'professional',
    },
    {
        label: lang.LBL_DESCRIPTION,
        link: false,
        columnName: 'description',
    },
];
const link_list = {
    routePath: 'institutionaldocs',
    title: 'Recent Active Invitees',
    search: {},
    sort: {
        order: 'asc',
        column: 'date_entered',
    },
    perPage: 10,
}
export default { metaList, link_list }